export const APPSTORE_URL = {
  ios: 'https://apps.apple.com/app/id1547603137',
  android:
    'https://play.google.com/store/apps/details?id=com.recharge.app.prod',
  ios_landing:
    'https://apps.apple.com/app/apple-store/id1547603137?pt=12113811&ct=web_webbanner_landingpage&mt=8',
  android_landing:
    'https://play.google.com/store/apps/details?id=com.recharge.app.prod&referrer=utm_source%3Dweb%26utm_medium%3Dwebbanner%26utm_campaign%3Dlandingpage',
}
